import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import UpcomingEvents from "./components/UpcomingEvents";
import MemoriesSection from "./components/MemoriesSection";
import ActivityCategories from "./components/ActivityCategories";
import WishPool from "./components/WishPool";
import AboutUs from "./components/AboutUs";
import BusinessEntry from "./components/BusinessEntry";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <UpcomingEvents />
      <MemoriesSection />
      <ActivityCategories />
      <WishPool />
      <AboutUs />
      <BusinessEntry />
      <FaqSection />
      <Footer />
    </div>
  );
}
